import styled, { css, keyframes } from 'styled-components';

import { TOP_BAR_HEIGHT } from '_constants/LAYOUT';

export { TOP_BAR_HEIGHT };
export const SEARCH_ROW_HEIGHT = 56;

const TEAL = '#2B4E56';
const TEXT = 'rgb(255, 237, 220)';
const CORAL = '#F5A687';
const CORAL_SOFT = '#FFEFE6';
const PANEL_TEXT = '#2B4E56';
const DIVIDER = 'rgba(43, 78, 86, 0.10)';
const DANGER = '#D9534F';

export const Root = styled.div``;

export const TopBar = styled.header`
  position: sticky;
  top: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  gap: 10px;
  height: ${TOP_BAR_HEIGHT}px;
  padding: 0 12px;
  background: ${TEAL};
  color: ${TEXT};
`;

export const IconButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: ${TEXT};
  cursor: pointer;
  transition: background 120ms ease;

  &:hover,
  &:focus-visible {
    background: rgba(255, 255, 255, 0.14);
    outline: none;
  }
`;

export const BrandGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;

export const BrandName = styled.span`
  color: ${TEXT};
  font-weight: 700;
  letter-spacing: 0.02em;
  font-size: 15px;
  line-height: 1;
  white-space: nowrap;
`;

export const AccountProduct = styled.span`
  color: ${CORAL};
  font-weight: 700;
  letter-spacing: 0.04em;
  font-size: 13px;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const RightCluster = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  flex-shrink: 0;
`;

export const BellBadge = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 7px;
  background: ${CORAL};
  color: ${TEAL};
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const AvatarCircle = styled.button`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${CORAL};
  color: ${TEAL};
  font-size: 10px;
  font-weight: 700;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus-visible {
    box-shadow: 0 0 0 2px rgba(245, 166, 135, 0.4);
    outline: none;
  }
`;

export const AccountWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const AccountPanel = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1150;
  min-width: 240px;
  padding: 6px;
  background: #ffffff;
  color: ${PANEL_TEXT};
  border: 1px solid ${DIVIDER};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 30, 35, 0.18);
`;

export const AccountHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 10px 8px;
`;

export const AccountHeaderAvatar = styled.span`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${CORAL};
  color: ${TEAL};
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const AccountHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const AccountName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${PANEL_TEXT};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AccountEmail = styled.span`
  font-size: 12px;
  color: rgba(43, 78, 86, 0.65);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AccountDivider = styled.div`
  height: 1px;
  margin: 4px 6px;
  background: ${DIVIDER};
`;

export const AccountItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  color: ${({ $danger }) => ($danger ? DANGER : PANEL_TEXT)};
  transition: background 120ms ease;

  &:hover,
  &:focus-visible {
    background: ${({ $danger }) => ($danger ? 'rgba(217, 83, 79, 0.10)' : CORAL_SOFT)};
    outline: none;
  }
`;

export const AccountItemIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: currentColor;
  flex-shrink: 0;
`;

export const SearchRow = styled.div`
  position: sticky;
  top: ${TOP_BAR_HEIGHT}px;
  z-index: 1099;
  display: flex;
  align-items: center;
  height: ${SEARCH_ROW_HEIGHT}px;
  padding: 8px 12px;
  background: ${TEAL};
`;

export const SearchTrigger = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  padding: 0 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 237, 220, 0.18);
  border-radius: 8px;
  color: rgba(255, 237, 220, 0.7);
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  transition: background 120ms ease, border-color 120ms ease, box-shadow 120ms ease;

  &:hover,
  &:focus-visible {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 237, 220, 0.4);
    box-shadow: 0 0 0 2px rgba(245, 166, 135, 0.4);
    outline: none;
  }
`;

export const SearchIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 237, 220, 0.7);
  flex-shrink: 0;
`;

export const SearchPlaceholder = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/* --- Drawer --- */

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
`;

export const DrawerBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(15, 30, 35, 0.45);
  display: flex;
  animation: ${fadeIn} 160ms ease;
`;

export const DrawerPanel = styled.aside`
  position: relative;
  display: flex;
  flex-direction: column;
  width: min(86vw, 360px);
  height: 100%;
  background: ${TEAL};
  color: ${TEXT};
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.25);
  animation: ${slideIn} 200ms ease;
`;

export const DrawerHeader = styled.header`
  display: flex;
  align-items: center;
  gap: 8px;
  height: ${TOP_BAR_HEIGHT}px;
  padding: 0 8px 0 16px;
  flex-shrink: 0;
`;

export const DrawerBrand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
`;

export const DrawerBrandLine1 = styled.span`
  color: ${TEXT};
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
`;

export const DrawerBrandLine2 = styled.span`
  color: ${CORAL};
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.08em;
  line-height: 1;
  text-transform: uppercase;
`;

export const DrawerCloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: ${TEXT};
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: rgba(255, 255, 255, 0.14);
    outline: none;
  }
`;

export const DrawerList = styled.ul`
  flex: 1;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  overflow-y: auto;
`;

export const DrawerItemRow = styled.button`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  background: transparent;
  border: 0;
  color: ${TEXT};
  font: inherit;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background 120ms ease;

  &:hover,
  &:focus-visible {
    background: rgba(255, 255, 255, 0.08);
    outline: none;
  }

  ${({ $active }) =>
    $active &&
    css`
      background: rgba(255, 255, 255, 0.1);
    `}
`;

export const ActiveAccent = styled.span`
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 0 2px 2px 0;
  background: ${CORAL};
`;

export const DrawerItemIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${TEXT};
`;

export const DrawerItemLabel = styled.span`
  flex: 1;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DrawerItemBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  background: ${CORAL};
  color: ${TEAL};
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
`;

export const DrawerItemChevron = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${TEXT};
  opacity: 0.7;
  transition: transform 160ms ease;
  transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
`;

export const DrawerSubList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 0 4px;
  background: rgba(0, 0, 0, 0.12);
`;

export const DrawerSubRow = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 56px;
  background: transparent;
  border: 0;
  color: ${TEXT};
  font: inherit;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  text-transform: capitalize;

  &:hover,
  &:focus-visible {
    background: rgba(255, 255, 255, 0.08);
    outline: none;
  }

  ${({ $active }) =>
    $active &&
    css`
      color: ${CORAL};
      font-weight: 600;
    `}
`;
